import React, { useState } from 'react';
import styled from 'styled-components';
import Name from '../Name/Name';
import Button from '../../../Button';

import { Call } from '@icons/communication';

interface ICLientSearchCard {
  className?: string;
  id: string;
  fullName: string;
  phone?: string;
  email?: string;
  emailable?: boolean;
  onCallClick?: () => void;
  onEmailClick?: () => void;
  onClick?: () => void;
}

const ClientSearchCard = ({
  id,
  fullName,
  phone = '',
  email = '',
  emailable = true,
  onCallClick,
  onEmailClick,
  ...props
}: ICLientSearchCard) => {
  const [isHovering, setIsHovering] = useState(false);
  const handleMouseHover = () => setIsHovering(prev => !prev);

  return (
    <StyledClientSearchCard {...props}>
      {id && <StyledIdentifier title={id}>{id}</StyledIdentifier>}
      <StyledName name={fullName} />

      {phone && (
        <StyledPhoneButton
          onClick={onCallClick}
          onMouseEnter={handleMouseHover}
          onMouseLeave={handleMouseHover}
        >
          <StyledLabel>{phone}</StyledLabel>
          {isHovering && <StyledPhoneIcon />}
        </StyledPhoneButton>
      )}

      {email && (
        <StyledEmailButton
          onClick={onEmailClick}
          disabled={!emailable}
          emailable={emailable}
        >
          <StyledEmailLabel>{email}</StyledEmailLabel>
        </StyledEmailButton>
      )}
    </StyledClientSearchCard>
  );
};

const StyledClientSearchCard = styled.div`
  background-color: #fff;
  height: 44px;
  width: 100%;
  padding: 14px 0px 14px 0px;
  display: flex;
`;

const StyledIdentifier = styled.div`
  padding-right: 9px;
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: normal;
  color: #919499;
  ::before {
    content: '#';
  }
`;

const StyledName = styled(Name)`
  font-size: 14px;
  white-space: nowrap;
  min-width: 150px;
  display: inline-block;
  vertical-align: middle;
  text-overflow: ellipsis;
  flex-grow: 1;
`;

const StyledButtonReset = styled(Button)`
  padding: 0;
  border: none;
  background: none;
`;

const StyledPhoneButton = styled(StyledButtonReset)`
  margin-left: 9px;
  font-size: 14px;
  text-align: center;
  font-family: inherit;
  text-decoration: none;
  width: auto;
  height: 18px;
  color: #919499;

  &:hover {
    color: #007aff;
  }

  &:disabled {
    pointer-events: none;
    svg path {
      stroke: #c2c5cc;
    }
  }
`;

const StyledEmailButton = styled(StyledButtonReset)`
  height: 18px;
  font-size: 14px;
  margin-left: 11px;
  text-align: center;
  font-family: inherit;
  text-decoration: none;
  width: auto;
  color: #919499;

  ${props =>
    props.emailable &&
    `
    &:hover {
      color: #007aff;
    }
  `}
`;

const StyledEmailLabel = styled.span`
  height: 17px;
  overflow: hidden;
  min-width: 119px;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  text-overflow: ellipsis;
`;

const StyledLabel = styled.span`
  height: 17px;
  overflow: hidden;
  max-width: 119px;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  text-overflow: ellipsis;
`;

const StyledPhoneIcon = styled(Call)`
  width: 17px;
  height: 17px;
  margin-left: 4px;
  display: inline-block;
  vertical-align: middle;
`;

export default ClientSearchCard;
